import React from 'react';

import { Text } from '@qality/common-components/src/atoms/Text';
import { ReportDateCell } from '@qality/common-model';
import { DateFormatService } from '@qality/common-service';

import { DateWrapperStyled } from './ReportColumn.styled';

type Props = {
  cell: ReportDateCell;
};

export default function ReportDateColumn({ cell }: Props): JSX.Element {
  return (
    <DateWrapperStyled>
      {cell ? (
        <Text>{DateFormatService.formatDate(cell, 'longDateFormat')}</Text>
      ) : (
        <Text inactive>None</Text>
      )}
    </DateWrapperStyled>
  );
}
